import { render, staticRenderFns } from "./SiteMenuItem.vue?vue&type=template&id=a64a95a4&scoped=true&"
import script from "./SiteMenuItem.vue?vue&type=script&lang=js&"
export * from "./SiteMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SiteMenuItem.vue?vue&type=style&index=0&id=a64a95a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64a95a4",
  null
  
)

export default component.exports